// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","partnerOfferCard":"Scz6z9o5tfmjb54x3wnSL"};